import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

export class FiltrosEnviosSM {
    exercicio?: number
    referencia?: number
    selectedUG: UnidadeGestoraResumida | null

    limpar(): void {
        this.exercicio = undefined
        this.referencia = undefined
        this.selectedUG = null 
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.exercicio)
            data.append("exercicio", String(this.exercicio))
        if (this.referencia !== undefined && this.referencia !== null)
            data.append("mes", String(this.referencia))
        if (this.selectedUG !== undefined && this.selectedUG !== null)
            data.append("ugPcm", String(this.selectedUG?.IdPCM))                        
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.exercicio)
            retorno += '&exercicio=' + this.exercicio
        if (this.referencia)
            retorno += '&mes=' + this.referencia
            if (this.selectedUG)
            retorno += '&ugPcm=' + this.selectedUG?.IdPCM
        return retorno
    }    
}